import { Collapse } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

import TableCell from '../../TableCell';
import TableRow from '../../TableRow';

const TableRowCollapse = ({ children, className, colSpan = 1, visible }) => {
  const { classes } = useStyles(styles);

  return (
    <TableRow className={className}>
      <TableCell
        className={classes.tableCellToggleCollapse}
        colSpan={colSpan}
        style={{ ...(!visible && { borderBottom: 'none' }) }}
      >
        <Collapse in={visible} timeout="auto" unmountOnExit>
          {children}
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

const styles = ({ shape: { borderRadius } }) => ({
  tableCellToggleCollapse: {
    width: '100%',
    padding: 0,
  },
});

TableRowCollapse.propTypes = {
  colSpan: PropTypes.number,
  visible: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default TableRowCollapse;
